import React from 'react';
import { Icon } from 'edcom-ui';
import styles from './Bottom.module.less';

export default function Bottom() {
  return (
    <div className={styles.container}>
      <div className={styles.socialWrapper}>
        <a
          href="https://www.facebook.com/Education.comFanPage"
          title="Facebook"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="facebook" />
        </a>
        <a
          href="https://www.instagram.com/education_com/"
          title="Instagram"
          rel="noopener"
          className={styles.social}
        >
          <svg
            className={styles.insIconWrapper}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
          </svg>
        </a>
        <a
          href="https://twitter.com/education_com"
          title="Twitter"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="twitter" />
        </a>
        <a
          href="https://www.youtube.com/user/brainzyxeducationcom"
          title="YouTube"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="youtube" />
        </a>
        <a
          href="https://www.pinterest.com/education_com/"
          title="Pinterest"
          rel="noopener"
          className={styles.social}
        >
          <Icon name="pinterest" />
        </a>
      </div>
      <div className={styles.ixlProducts}>
        <a className={styles.boxIxlProducts} href="https://www.ixl.com/">
          <h5>IXL</h5>
          <p>Comprehensive K-12 personalized learning</p>
        </a>
        <div className={styles.boxDivider} />
        <a
          className={styles.boxIxlProducts}
          href="https://www.rosettastone.com/"
        >
          <h5>Rosetta Stone</h5>
          <p>Immersive learning for 25 languages</p>
        </a>
        <div className={styles.boxDivider} />
        <a className={styles.boxIxlProducts} href="https://www.wyzant.com/">
          <h5>Wyzant</h5>
          <p>Trusted tutors for 300 subjects</p>
        </a>
        <div className={styles.boxDivider} />
        <a className={styles.boxIxlProducts} href="https://www.vocabulary.com/">
          <h5>Vocabulary.com</h5>
          <p>Adaptive learning for English vocabulary</p>
        </a>
        <div className={styles.boxDivider} />
        <a className={styles.boxIxlProducts} href="https://www.abcya.com/">
          <h5>ABCya</h5>
          <p>Fun educational games for kids</p>
        </a>
        <div className={styles.boxDivider} />
        <a
          className={styles.boxIxlProducts}
          href="https://www.spanishdict.com/"
        >
          <h5>SpanishDict</h5>
          <p>Spanish-English dictionary, translator, and learning</p>
        </a>
        <div className={styles.boxDivider} />
        <a className={styles.boxIxlProducts} href="https://emmersion.ai/">
          <h5>Emmersion</h5>
          <p>Fast and accurate language certification</p>
        </a>
        <div className={styles.boxDivider} />
        <a
          className={styles.boxIxlProducts}
          href="https://www.teacherspayteachers.com/"
        >
          <h5>TPT</h5>
          <p>Marketplace for millions of educator-created resources</p>
        </a>
      </div>
      <div>
        <a
          href="https://www.kidsafeseal.com/certifiedproducts/education.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            border="0"
            alt="Education.com is certified by the kidSAFE Seal Program."
            src="https://www.kidsafeseal.com/sealimage/50473324616348843/education_small_whitetm.png"
          />
        </a>
      </div>
      <div className={styles.copyright}>
        <p>
          Copyright © {new Date().getFullYear()} Education.com, Inc, a division
          of IXL Learning • All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
